


























import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'PolygonsTable'
  components: { LoadingIndicator }
  vue:
    props: ['snapshot', 'actions']
    computed:
      sidesCount: ->
        @snapshot.geo_polygon.features[0].geometry.coordinates[0].length - 1

export default VueOptions.vue settings
